module.exports = __webpack_public_path__ + "static/media/open-mobile.bf29b5ef.png";